document.addEventListener('DOMContentLoaded', () => {
  if (typeof Swiper === 'undefined') return;

  const sliders = document.querySelectorAll('.hero-banner-slider');

  sliders.forEach((el) => {
    const autoplay = el.dataset.autoplay === 'true';
    const speed = parseInt(el.dataset.autoplaySpeed, 10) || 6000;
    const prevEl = el.querySelector('.swiper-button-prev');
    const nextEl = el.querySelector('.swiper-button-next');
    const paginationEl = el.querySelector('.swiper-pagination');

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 600,
      autoHeight: false,
      resizeObserver: false,
      autoplay: autoplay ? { delay: speed, disableOnInteraction: false } : false,
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
      },
      navigation: prevEl && nextEl ? { prevEl: prevEl, nextEl: nextEl } : false,
      pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
      a11y: { enabled: true },
    });
  });
});
